module.exports = __webpack_public_path__ + "img/key_active.8b77a9fc.svg";